<template>
<div>
  <h1>Edit Task</h1>
  <div v-if="row && dataItem">
    <label>{{ $t('key and id') }}</label>
    <input v-model="row.key" class="form-text" type="text"/>
    <label>{{ $t('task') }}</label>
    <select v-model="dataItem.task" class="custom-select mb-2">
      <option v-for="(value, index) in Object.values(TaskManagerTaskTypes)" :key="index" :value="value">{{
          value
        }}
      </option>
    </select>
    <label>{{ $t('targetType') }}</label>
    <input v-model="dataItem.targetType" class="form-text" type="text"/>
    <label>{{ $t('userId') }}</label>
    <input v-model="dataItem.userId" class="form-text" type="text"/>
    <label>{{ $t('prio') }}</label>
    <input v-model="dataItem.prio" class="form-text" type="text"/>
    <label>{{ $t('status') }}</label>
    <input v-model="dataItem.status" class="form-text" type="text"/>
    <label class="vform-label white medium mb-0 pb-0 mt-3">{{ $t('selectVM') }}</label>
    <vm-selector :pre-set-value="dataItem.virtualMachine ? dataItem.virtualMachine : null"
                 class="mb-3 col-12 col-md-6" @selected="setVM"/>
    <Button class="mt-2" @click="saveTask">{{ $t('saveTask') }}</Button>
  </div>
</div>
</template>

<script>
import {TaskManagerTaskTypes} from "@/enum.js";
import vmSelector from "@/components/vmSelector.vue";
import Button from "@/components/forms/Button.vue";
export default {
  name: "TaskManagerEditForm",
  components: {Button, vmSelector},
  props: {
    remoteRow: {type: Object, required: true}
  },
  data() {
    return {
      row: {},
      dataItem: {},
      TaskManagerTaskTypes
    }
  },
  watch: {
    remoteRow: {
      handler() {
        this.setRowAndData();
      },
      deep: true
    }
  },
  beforeMount() {
    this.setRowAndData();
  },
  methods: {
    setRowAndData() {
      this.row = JSON.parse(JSON.stringify(this.remoteRow));
      this.dataItem = this.row.data;
    },
    setVM(vm) {
      this.dataItem.virtualMachine = vm;
    },
    saveTask() {
      this.row.data = this.dataItem;
      this.$emit('saveTask', this.row);
    }
  }
}
</script>

<style scoped lang="scss">

</style>